import * as React from 'react';

import { controlChromeVariants } from '@playbooks/ui/components/component-recipes';
import { cn } from '@playbooks/ui/lib/utils';

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
	// Theme
	const rootClassName = cn(
		controlChromeVariants(),
		'flex field-sizing-content min-h-16 w-full px-3 py-2 text-base md:text-sm',
		className,
	);

	// Render
	return <textarea data-slot='textarea' className={rootClassName} {...props} />;
}

export { Textarea };
